interface StakingPoolTvl {
  totalValueLockedUSD: number | string;
}

export const sumStakingTvlUsd = (
  stakingPools: readonly StakingPoolTvl[] | undefined
): number =>
  stakingPools?.reduce((total, pool) => {
    const poolTvl = Number(pool.totalValueLockedUSD);
    return total + (Number.isFinite(poolTvl) ? poolTvl : 0);
  }, 0) ?? 0;
